import React from 'react'
import { connect } from 'react-redux'
import { mapStateToProps } from '../../../layout/authorised-layout/current-reg-holder/container'
import { FormInput } from '@myxplor/forms'

const handleChange = () => {}

const RegHolderInput = ({ readOnly, current_reg_holder }) => (
  <FormInput
    required={!readOnly}
    label='Centre Name'
    name='centre_name'
    value={current_reg_holder.name || 'Loading...'}
    type='text'
    autoFocus={false}
    onChange={handleChange}
    htmlInput={{readOnly: true}}
  />
)

export default connect(mapStateToProps)(RegHolderInput)



// WEBPACK FOOTER //
// ./src/care-enrolments/accs/form/reg-holder-input.jsx